module.exports = __webpack_public_path__ + "static/media/img7.fcaa2dd1.jpg";